<template>
    <div class="flex flex-col items-center text-sm text-grey-dark">
        <base-svg
            :key="icon"
            :name="icon"
            class="w-6 h-6 mb-2"
        />

        <template v-if="error">
            Unable to load

            <button
                v-if="retry"
                type="button"
                class="text-blue"
                @click.prevent="retry"
            >
                Retry
            </button>
        </template>
        <template v-else>
            {{ loadingText }}
        </template>
    </div>
</template>

<script>
    export default {
        props: {
            error: {
                default: null,
                validator: value => value instanceof Error || value === null
            },
            retry: {
                type: Function,
                default: null
            },
            loadingText: {
                type: String,
                default: 'Loading...'
            }
        },
        computed: {
            icon () {
                return this.error ? 'icon-important-circle' : 'icon-loading'
            }
        }
    }
</script>
